export enum DocumentProgressStatus {
  Rejected = 'Rejected By Developer',
  Cancelled =  'Cancelled By Sales Rep'
}